import React from "react";
import { useTranslation } from "react-i18next"; // For localization
import { Box, Divider, Typography, useTheme } from "@mui/material";
import internationalImg from "images/business/international-market.svg";
import ChineseMarketContentMobileView from "./ChineseMarketContentMobileView";
import BgTitle from "components/title/BgTitle";
const ChineseMarketMobile = () => {
  const { t } = useTranslation(); // Initialize translation hook
  const theme = useTheme();

  return (
    <Box sx={{ mt: 4, mb: 2 }} id="chinese-market">
      {/* Header and Description */}
      <Divider />
      <BgTitle
        text={t("business.chineseMarketSupport.heading")}
        isCenter={true}
      />

      {/* Image */}
      <Box
        sx={{
          mt: 1,
          textAlign: "center", // Center-align image
          marginBottom: theme.spacing(4),
        }}
      >
        <Box
          component="img"
          src={internationalImg}
          alt="Chinese Market Support"
          sx={{
            width: "100%",
            maxWidth: "300px", // Limit image size
            borderRadius: 2, // Rounded corners
            boxShadow: 3, // Add shadow
            margin: "auto", // Center image
          }}
        />
      </Box>
      <Box
        sx={{
          borderLeft: 2,
          bgcolor: "#f5f5f5",
          borderColor: "primary.main",
          p: 1,
          mb: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary, // Use secondary text color
            fontSize: "0.8rem",
          }}
        >
          {t("business.chineseMarketSupport.description")}
        </Typography>
      </Box>

      {/* Content Section */}
      <ChineseMarketContentMobileView />
    </Box>
  );
};

export default ChineseMarketMobile;
